import { MediaItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { RocheNewsImporterListItem } from '../../search/data-search/list-items/news-importer-list-item';
import { fetchAdhocList, fetchAdhocTabs } from '../../search/data-search/queries';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

export const RocheMediaReleasesInvestorUpdatesAdhoc = ({ slot }: Props): JSX.Element => {
  return (
    <DataSearchView<MediaItem>
      slot={slot}
      searchTrackingType={SearchTrackingType.AD_HOC}
      tabName='year'
      pageName='page'
      queryName='query'
      fetchTabs={fetchAdhocTabs}
      fetchList={fetchAdhocList}
      itemRenderer={(item, index, trackingData) => (
        <RocheNewsImporterListItem key={`${item.Slug}-${index}`} item={item} trackingData={trackingData} />
      )}
    />
  );
};
